export default "__VITE_ASSET__BhQh0Bdz__"